import { render, staticRenderFns } from "./ProductMenuLinks.vue?vue&type=template&id=543134f9&scoped=true&"
import script from "./ProductMenuLinks.vue?vue&type=script&lang=ts&"
export * from "./ProductMenuLinks.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMenuLinks.vue?vue&type=style&index=0&id=543134f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543134f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VItemGroup,VRow})
